export default __webpack_public_path__ + "static/Gwen-2250716fe146f40e2bd247e2de1d58d7.jpeg";